import { createFileRoute } from '@tanstack/react-router';

import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { RoleEditorPage } from '@/pages/settings/roles/RoleEditorPage';

export const Route = createFileRoute('/_authenticated/_app/settings/roles/$roleId')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageMembers'] }),
	component: EditRoleRoute,
});

function EditRoleRoute() {
	const { roleId } = Route.useParams();
	return <RoleEditorPage mode={{ kind: 'edit', roleId }} />;
}
